import { css } from 'lit';

export const IxDateNextStyles = css`
  :host {
    display: block;
  }

  :host(vaadin-date-picker) {
    width: 100%;
  }

  :host ::part(label) {
    background-color: #ffffff;
    margin-bottom: 0.5rem;
    min-height: auto !important;
    left: 0.625rem;
    padding: 0 0.25rem;
    width: auto;
    top: -0.5rem;
    font-size: 1rem;
    z-index: 1;
  }

  :host ::part(required-indicator) {
    margin-left: 0.75rem;
  }

  vaadin-date-picker {
    font-family: 'Open Sans', 'sans-serif';
    font-size: 1rem;
    height: 2.5rem;
    width: 100%;
    padding-top: 0 !important;
    padding-bottom: 0 !important;

    --vaadin-field-default-border-bottom: none;
    --material-primary-text-color: var(--clr-on-surface-primary, #1456e0);

    &::before {
      display: none;
    }

    &::part(toggle-button) {
      margin-right: 0.625rem;
    }

    &::part(input-field) {
      background: transparent;
      border: 1px solid var(--custom-border-color, #09224180);
      border-radius: 0.25rem;
      height: 2.75rem;
      padding: 0.25rem !important;
    }

    & > input {
      font-size: 1rem;
      height: 1.25rem;
      margin-left: 1rem;
      padding: 0 !important;
      --_hover-highlight: transparent;
    }

    & > label {
      padding-bottom: 0.3125rem;
    }

    & > [slot='error-message'] {
      color: var(--clr-on-surface-critical, #db0028);
      font-size: 0.75rem;
      margin-left: 1rem;
    }

    &:hover::part(input-field) {
      border: 1px solid var(--custom-border-color, #000000ff);
    }

    &[focused]:not([invalid]) {
      --custom-border-color: var(--clr-on-surface-primary, #1456e0);

      &::part(toggle-button) {
        color: var(--clr-on-surface-primary, #1456e0);
      }
    }

    &[invalid] {
      &::part(toggle-button) {
        color: var(--clr-on-surface-critical, #db0028);
      }

      &::part(input-field) {
        --vaadin-input-field-border-color: color: var(
            --clr-on-surface-critical,
            #db0028
          );
        --_focus-ring-color: var(--clr-on-surface-critical, #db0028);
        border-color: var(--clr-on-surface-critical, #db0028);
        border-width: 2px;
      }

      &:not([has-value]):not([focused])::part(label) {
        transform: scale(1) translateY(1.5rem);
        color: var(--clr-on-surface-critical, #db0028);
      }

      &:hover > label {
        color: var(--clr-on-surface-critical, #db0028);
      }
    }

    &[invalid][focused]::part(input-field) {
      border-width: 2px;
    }
    &[invalid]:hover:not([focused])::part(input-field) {
      border-width: 1px;
      padding-left: 0.3rem !important;
    }
    &[invalid][focused]::part(label) {
      color: var(--clr-on-surface-critical, #db0028);
    }

    &[has-error-message] {
      box-shadow: none;
      border: none;
      height: 3.75rem;
    }

    :host &[invalid]:not([has-value]):not([focused])::part(required-indicator) {
      transform: scale(1) translateY(1.5rem);
    }
    :host &[invalid][focused]::part(required-indicator) {
      color: var(--clr-on-surface-critical, #db0028);
    }
    :host &[invalid]:hover::part(required-indicator) {
      color: var(--clr-on-surface-critical, #db0028);
    }
  }

  vaadin-date-picker::part(input-field)::before,
  vaadin-date-picker::part(input-field)::after {
    display: none;
    content: none;
    height: 0;
    background-color: transparent;
  }
`;
